import { CircularProgress } from '@material-ui/core';
import _ from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ItemContent from '../../../../components/ItemContent/ItemContent';
import CustomLabel from '../../../../components/LabelWithPars/components/CustomLabel';
import { EPaths } from '../../../../types/enums/EPaths';
import { IEditForm } from '../../../../types/interfaces/IEditForm';
import { NSConfigs } from '../../../../types/interfaces/NSConfigs';
import { endpoints } from '../../../../utils/endpoints';
import tPaths from '../../../../utils/tPaths';
import useDescLangs from '../../../../utils/useDescLangs';

function fieldsOfFirstLanguage(fields: any) {
  const lang = Object.keys(fields)[0];
  return fields[lang];
}
const PaymentMethods = ({ editable }: { editable: boolean }) => {
  const { languagesList, reduceLangsList } = useDescLangs();
  const { t } = useTranslation();

  const descriptionMapper = useCallback(
    (data: NSConfigs.IPaymentMethods[]): IEditForm[][] => {
      return [
        data.map((d) => ({
          fieldName: d.name,
          type: 'switch',
          label: <CustomLabel label={d.name} localStyles={{ width: 90 }} />,
          initialValue: d.available,
        })),
      ];
    },
    [t],
  );

  const tabs = useMemo(
    () => [...languagesList.map((lang) => ({ key: lang.key, label: lang.display }))],
    [languagesList],
  );

  const tabsContentMapper = useCallback(
    (data: NSConfigs.IPaymentMethods[]) => ({
      ...languagesList.reduce(
        (acc, cv) => ({
          ...acc,
          [cv.key]: descriptionMapper(data),
        }),
        {},
      ),
    }),
    [descriptionMapper, languagesList],
  );

  const updateDataFormatter = useCallback(
    (fields: any): { paymentMethods: NSConfigs.IPaymentMethods[] } => {
      const fieldsWithValue = fieldsOfFirstLanguage(fields);
      return {
        paymentMethods: Object.keys(fieldsWithValue).map((key) => ({
          name: key,
          available: fieldsWithValue[key].value,
        })),
      };
    },
    [reduceLangsList],
  );

  return (
    <>
      {languagesList.length ? (
        <ItemContent
          path={EPaths.LegalLinks}
          title={t(tPaths.configs.paymentMethods)}
          tabs={tabs}
          tabsContentMapper={tabsContentMapper}
          updateDataFormatter={updateDataFormatter}
          apiUrl={endpoints.paymentMethods}
          backButton={false}
          editable={editable}
        />
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default PaymentMethods;
